export interface ProviderList {
  total: number;
  page: number;
  resultsPerPage: number;
  previous: string;
  next: string;
  lists: Lists[];
}

interface Lists {
  id: string;
  clientUserId: string;
  createdAt: string;
  items: Items[];
}
interface Items {}

export interface GeoLocation {
  City: string;
  Zip: string;
}

export class ZelisApiError {
  Code: string;
  Error: string;
}

export class GroupedByProviderRequest {
  ZipCode: string;
  CarrierId: string;
  ProviderType: string;
  ProviderName: string;
  ProviderId: number;

  constructor(
    ZipCode: string,
    CarrierId: string,
    ProviderType: string,
    ProviderName: string,
    ProviderId: number,
  ) {
    this.ZipCode = ZipCode;
    this.CarrierId = CarrierId;
    this.ProviderType = ProviderType;
    this.ProviderName = ProviderName;
    this.ProviderId = ProviderId;
  }
}
